import React from 'react';
import { Link } from 'react-location';
import { Container } from 'Core/components/Layout';
import { cardPreferenceCenterPath } from 'Modules/deposit/routes';
import logoStripe from 'url:Images/powered_by_stripe_white.svg';

export default function Header({
  title,
  subtitle,
  withCardPrefCenterLink,
  branding = 'default',
  showStripeLogo = false,
}) {
  const isPatientfi = branding === 'patientfi';
  const finalBranding = branding || 'default';
  const classes = {
    patientfi: 'bg-patientfi-bg text-patientfi-text',
    fortiva: 'bg-fortiva-bg text-fortiva-text',
    lendflow: 'bg-lendflow-bg text-lendflow-text',
    default: 'bg-primary text-white',
    flexHeight: subtitle ? 'h-full' : '',
    subtitleColor: isPatientfi ? 'text-patientfi-text' : 'text-gray-300',
  };
  return (
    <header className={`${classes[finalBranding]} px-4 mb-4 h-16`}>
      <Container className={`!mb-0 !h-full !px-4 !flex !items-center !justify-between`}>
        <div className={`${classes.flexHeight} flex flex-col py-2`}>
          <h2 className="m-0" data-testid="header-headline">
            {title}
          </h2>
          <div className={`${classes.subtitleColor} text-sm`}>{subtitle}</div>
        </div>
        {withCardPrefCenterLink && (
          <Link data-testid="card-pref-center-link" to={cardPreferenceCenterPath} search={true}>
            Card Preference Center
          </Link>
        )}
        {showStripeLogo && (
          <a href="https://stripe.com/" target="_blank" rel="noreferrer">
            <img src={logoStripe} alt="powered by stripe" style={{ height: '28px' }} />
          </a>
        )}
      </Container>
    </header>
  );
}
